import React from 'react';
import { CircleIcon } from '@tanium/react-composed-icons';
import styled from '@tanium/react-emotion';
import { InfoIcon } from '@tanium/react-graphics';
import { useTheme } from '@tanium/react-theme-context';
import { Placement, SimpleTooltip } from '@tanium/react-tooltip';
import { IconFill, IconForeground } from './themeDefinitions';

export interface Props {
  /**
   * Background color behind the circle info icon.
   */
  backgroundColor?: string;
  /**
   * Content to be displayed inside the tooltip.
   */
  content: React.ReactNode;
  /**
   * Icon color of the circle info icon.
   */
  iconColor?: string;
  /**
   * Placement of the tooltip. Follows popper's conventions. Note that placements are a "best
   * attempt," and if the underlying library detects that the tooltip will not render well, it will
   * try other placements.
   */
  placement?: Placement;
}

const StyledCircleIcon = styled(CircleIcon)({ display: 'block' });

const IconContainer = styled('div')({ display: 'inline-block' });

export const InfoTooltip = ({ backgroundColor, content, iconColor, placement }: Props) => {
  const theme = useTheme();
  return (
    <SimpleTooltip content={content} placement={placement}>
      {({ ref }) => (
        <IconContainer ref={ref}>
          <StyledCircleIcon
            icon={InfoIcon}
            outerRadius={8}
            innerRadius={5}
            backgroundColor={backgroundColor || IconFill(theme)}
            iconColor={iconColor || IconForeground(theme)}
          />
        </IconContainer>
      )}
    </SimpleTooltip>
  );
};
